import { IdNameApiModel } from '../../IdNameApiModel';
import { ActivityTypeListApiModel } from '../../site-settings/activity-types/ActivityTypeListApiModel';

export class PendingTasksReportFiltersApiModel {
  public Phases: IdNameApiModel[];
  public ActivityTypes: ActivityTypeListApiModel[];
  public MaxCurrentScore: number;

  public deserialize?(data: Object): PendingTasksReportFiltersApiModel {
    Object.assign(this, data);

    this.ActivityTypes = this.ActivityTypes.map((x) => new ActivityTypeListApiModel().deserialize(x));

    return this;
  }
}
